import { SCTMApi, AllocatedControlApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

const brmApiClient = new BrmApiClient();

export const sctmApi = new SCTMApi(brmApiClient);
export const allocatedControlApi = new AllocatedControlApi(brmApiClient);
